<div
  class="fixed inset-0 z-20 flex items-center justify-center bg-main-background bg-opacity-75 backdrop-blur-sm"
  (click)="closed.emit()">
  <div
    class="mx-4 flex max-h-[80vh] w-full max-w-xl flex-col rounded-md bg-white shadow-lg"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center justify-between border-b px-6 py-4">
      <h2 class="oswald-font text-xl text-nside-gray-400">Add User</h2>
      <button type="button" (click)="closed.emit()" class="rounded p-1 hover:bg-gray-100">
        <lucide-icon [img]="icons.X" [size]="20"></lucide-icon>
      </button>
    </div>

    <!-- Tabs -->
    <div class="flex border-b px-6">
      <button
        type="button"
        (click)="switchTab('building')"
        class="oswald-font -mb-px border-b-2 px-4 py-3 text-sm transition-colors"
        [ngClass]="activeTab === 'building'
          ? 'border-nside-orange-400 text-nside-orange-400'
          : 'border-transparent text-gray-500 hover:text-gray-700'">
        Building Users
      </button>
      <button
        type="button"
        (click)="switchTab('contacts')"
        class="oswald-font -mb-px border-b-2 px-4 py-3 text-sm transition-colors"
        [ngClass]="activeTab === 'contacts'
          ? 'border-nside-orange-400 text-nside-orange-400'
          : 'border-transparent text-gray-500 hover:text-gray-700'">
        Contacts
      </button>
    </div>

    <!-- Access type selector -->
    <div class="flex items-center gap-3 bg-gray-50 px-6 py-3">
      <label class="whitespace-nowrap text-sm font-medium text-gray-600">Access type:</label>
      <ng-container *ngIf="activeTab === 'building'; else contactsAccessType">
        <select
          [(ngModel)]="selectedAccessType"
          class="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 focus:border-blue-500 focus:ring-blue-500">
          <option *ngFor="let type of accessTypeOptions" [value]="type">{{ type }}</option>
        </select>
      </ng-container>
      <ng-template #contactsAccessType>
        <span class="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
          Message Only
        </span>
        <span class="text-xs text-gray-400">(contacts can only receive messages)</span>
      </ng-template>
    </div>

    <!-- Search -->
    <div class="px-6 pt-3 pb-2">
      <div class="relative">
        <div class="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
          <lucide-icon [img]="icons.Search" [size]="16"></lucide-icon>
        </div>
        <input
          type="search"
          [(ngModel)]="searchQuery"
          (input)="filterList()"
          placeholder="Search..."
          class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 ps-9 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
      </div>
    </div>

    <!-- List -->
    <div class="flex-1 overflow-y-auto px-6 pb-4">

      <!-- Loading state -->
      <ng-container *ngIf="loading">
        <div class="flex flex-col items-center justify-center gap-2 py-10 text-gray-400">
          <div class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-nside-orange-400"></div>
          <p class="text-xs">Loading...</p>
        </div>
      </ng-container>

      <!-- Tab content (hidden while loading) -->
      <ng-container *ngIf="!loading">
      <!-- Building Users tab -->
      <ng-container *ngIf="activeTab === 'building'">
        <ng-container *ngIf="filteredBuildingContacts.length > 0; else emptyBuilding">
          <div
            *ngFor="let contact of filteredBuildingContacts"
            class="flex items-center justify-between border-b py-3 last:border-0">
            <div>
              <p class="text-sm font-medium text-gray-900">{{ contact.name }}</p>
              <p class="text-xs text-gray-500">{{ contact.email }} · {{ contact.department }}</p>
            </div>
            <button
              type="button"
              (click)="addUser(contact)"
              [disabled]="isAlreadyAdded(contact.id)"
              class="rounded border px-3 py-1 text-xs oswald-font transition-colors"
              [ngClass]="isAlreadyAdded(contact.id)
                ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                : 'border-nside-orange-400 text-nside-orange-400 hover:bg-orange-50'">
              {{ isAlreadyAdded(contact.id) ? 'Added' : 'Add' }}
            </button>
          </div>
        </ng-container>
        <ng-template #emptyBuilding>
          <p class="py-8 text-center text-sm italic text-gray-400">No users found.</p>
        </ng-template>
      </ng-container>

      <!-- Contacts tab -->
      <ng-container *ngIf="activeTab === 'contacts'">
        <ng-container *ngIf="filteredContacts.length > 0; else emptyContacts">
          <div
            *ngFor="let contact of filteredContacts"
            class="flex items-center justify-between border-b py-3 last:border-0">
            <div>
              <p class="text-sm font-medium text-gray-900">{{ contact.name }}</p>
              <p class="text-xs text-gray-500">{{ contact.email }} · {{ contact.department }}</p>
            </div>
            <button
              type="button"
              (click)="addUser(contact)"
              [disabled]="isAlreadyAdded(contact.id)"
              class="rounded border px-3 py-1 text-xs oswald-font transition-colors"
              [ngClass]="isAlreadyAdded(contact.id)
                ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                : 'border-nside-orange-400 text-nside-orange-400 hover:bg-orange-50'">
              {{ isAlreadyAdded(contact.id) ? 'Added' : 'Add' }}
            </button>
          </div>
        </ng-container>
        <ng-template #emptyContacts>
          <p class="py-8 text-center text-sm italic text-gray-400">No contacts available.</p>
        </ng-template>
      </ng-container>
      </ng-container> <!-- end *ngIf="!loading" -->

    </div>

    <!-- Footer -->
    <div class="flex justify-end border-t px-6 py-3">
      <button
        type="button"
        (click)="closed.emit()"
        class="rounded-md border border-gray-300 px-4 py-1.5 text-sm oswald-font text-gray-600 hover:bg-gray-50">
        Close
      </button>
    </div>

  </div>
</div>
